import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Phone, Clock, MapPin, Award, Wrench, Home, Shield, Droplet, Zap, CheckCircle, Users, AlertTriangle, Gauge } from 'lucide-react';
import { SchemaInjector } from '../components/SchemaInjector';

const ArvadaPlumber = () => {
  // Unified Schema for the entire page
  const completePageSchema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "@id": "https://colorado-plumbing.com/arvada-plumber#webpage",
        "url": "https://colorado-plumbing.com/arvada-plumber",
        "name": "Arvada Plumber | Water Heater & Sewer Repair | Colorado First Plumbing",
        "description": "Your trusted Arvada plumber with transparent pricing. Get a 40-gal water heater for $2,000 or a sewer repair for $5,000. 360 Google Reviews. No hidden fees.",
        "isPartOf": { "@id": "https://colorado-plumbing.com/#website" },
        "breadcrumb": { "@id": "https://colorado-plumbing.com/arvada-plumber#breadcrumb" }
      },
      {
        "@type": "BreadcrumbList",
        "@id": "https://colorado-plumbing.com/arvada-plumber#breadcrumb",
        "itemListElement": [
          { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://colorado-plumbing.com/" },
          { "@type": "ListItem", "position": 2, "name": "Arvada Plumber", "item": "https://colorado-plumbing.com/arvada-plumber" }
        ]
      },
      {
        "@type": "Plumber",
        "@id": "https://colorado-plumbing.com/",
        "name": "Colorado First Plumbing and Sewer LLC",
        "description": "Licensed Master Plumber in the Denver Metro area offering transparent, flat-rate pricing for residential and commercial plumbing and sewer services.",
        "image": "https://colorado-plumbing.com/colorado-plumbing-uploads/brand/Colorado-First-Plumbing-Logo-Transparent.png",
        "logo": "https://colorado-plumbing.com/colorado-plumbing-uploads/brand/Colorado-First-Plumbing-Logo-Transparent.png",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "5108 Sydney Ave",
          "addressLocality": "Littleton",
          "addressRegion": "CO",
          "postalCode": "80130",
          "addressCountry": "US"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": 39.53934,
          "longitude": -104.92936
        },
        "url": "https://colorado-plumbing.com/arvada-plumber",
        "aggregateRating": { "@type": "AggregateRating", "ratingValue": "4.8", "reviewCount": "360" },
        "openingHoursSpecification": [
          {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            "opens": "08:00",
            "closes": "17:00"
          },
          {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": "Sunday",
            "opens": "00:00",
            "closes": "00:00"
          }
        ],
        "areaServed": [
          { "@type": "City", "name": "Arvada" }
        ],
        "hasMap": "https://maps.app.goo.gl/T8cAeQbDFS4hP7qQ8",
        "publicAccess": false,
        "sameAs": [
          "https://www.facebook.com/coloradoplumbing/",
          "https://g.co/kgs/xd3PznG",
          "https://www.tiktok.com/@milehighplumber",
          "https://www.youtube.com/@bestmasterplumber",
          "https://www.instagram.com/coloradofirstplumbing/",
          "https://birdeye.com/colorado-first-plumbing-and-sewer-llc-172384402926614",
          "https://www.bbb.org/us/co/highlands-ranch/profile/plumber/colorado-first-plumbing-and-sewer-llc-1296-90268915",
          "https://www.buildzoom.com/contractor/colorado-first-plumbing-and-sewer-inc"
        ],
        "service": [
          {
            "@type": "Service",
            "name": "Water Heater Installation - Arvada",
            "serviceType": "Plumbing Service",
            "description": "Professional water heater replacement services in Arvada, including old unit removal, new installation, permits, and inspection. We offer 40-gallon and 50-gallon units with transparent pricing.",
            "provider": { "@id": "https://colorado-plumbing.com/" },
            "areaServed": { "@type": "City", "name": "Arvada" },
            "offers": {
              "@type": "Offer",
              "priceCurrency": "USD",
              "price": "2000",
              "availability": "https://schema.org/InStock",
              "url": "https://colorado-plumbing.com/arvada-plumber#water-heater-installation"
            }
          },
          {
            "@type": "Service",
            "name": "Bradford White Water Heater Installation - Arvada",
            "serviceType": "Plumbing Service",
            "description": "Installation of high-quality Bradford White water heaters in Arvada Available in 40-gallon ($2,300) and 50-gallon ($2,400) sizes.",
            "provider": { "@id": "https://colorado-plumbing.com/" },
            "areaServed": { "@type": "City", "name": "Arvada" },
            "offers": {
              "@type": "Offer",
              "priceCurrency": "USD",
              "price": "2300",
              "availability": "https://schema.org/InStock",
              "url": "https://colorado-plumbing.com/arvada-plumber#bradford-white-water-heater"
            }
          },
          {
            "@type": "Service",
            "name": "Tankless Water Heater Installation - Arvada",
            "serviceType": "Plumbing Service",
            "description": "Efficient tankless water heater installation in Arvada, providing endless hot water and energy savings. $5,000 for replacement, $8,000 for new installation.",
            "provider": { "@id": "https://colorado-plumbing.com/" },
            "areaServed": { "@type": "City", "name": "Arvada" },
            "offers": {
              "@type": "Offer",
              "priceCurrency": "USD",
              "price": "5000",
              "availability": "https://schema.org/InStock",
              "url": "https://colorado-plumbing.com/arvada-plumber#tankless-water-heater"
            }
          },
          {
            "@type": "Service",
            "name": "Sewer Camera Inspection - Arvada",
            "serviceType": "Plumbing Service",
            "description": "Non-invasive sewer camera inspection to accurately diagnose blockages, leaks, and damage in Arvada sewer lines, providing clear video assessment for $175.",
            "provider": { "@id": "https://colorado-plumbing.com/" },
            "areaServed": { "@type": "City", "name": "Arvada" },
            "offers": {
              "@type": "Offer",
              "priceCurrency": "USD",
              "price": "175",
              "availability": "https://schema.org/InStock",
              "url": "https://colorado-plumbing.com/arvada-plumber#sewer-camera"
            }
          },
          {
            "@type": "Service",
            "name": "Sewer Spot Repair - Arvada",
            "serviceType": "Plumbing Service",
            "description": "Professional sewer spot repair services in Arvada, addressing cracks, breaks, and blockages with efficient solutions. $5,000 for yard repairs, $9,500 for street repairs.",
            "provider": { "@id": "https://colorado-plumbing.com/" },
            "areaServed": { "@type": "City", "name": "Arvada" },
            "offers": {
              "@type": "Offer",
              "priceCurrency": "USD",
              "price": "5000",
              "availability": "https://schema.org/InStock",
              "url": "https://colorado-plumbing.com/arvada-plumber#sewer-spot-repair"
            }
          },
          {
            "@type": "Service",
            "name": "Sewer Line Replacement - Arvada",
            "serviceType": "Plumbing Service",
            "description": "Full sewer line replacement services in Arvada using trenchless pipe bursting technology. $12,000 flat rate includes all new piping, labor, and permits.",
            "provider": { "@id": "https://colorado-plumbing.com/" },
            "areaServed": { "@type": "City", "name": "Arvada" },
            "offers": {
              "@type": "Offer",
              "priceCurrency": "USD",
              "price": "12000",
              "availability": "https://schema.org/InStock",
              "url": "https://colorado-plumbing.com/arvada-plumber#sewer-replacement"
            }
          },
          {
            "@type": "Service",
            "name": "Root Removal - Arvada",
            "serviceType": "Plumbing Service",
            "description": "Professional sewer root removal in Arvada using specialized Milwaukee cutting equipment. $495 for basement access, $695 for toilet access.",
            "provider": { "@id": "https://colorado-plumbing.com/" },
            "areaServed": { "@type": "City", "name": "Arvada" },
            "offers": {
              "@type": "Offer",
              "priceCurrency": "USD",
              "price": "495",
              "availability": "https://schema.org/InStock",
              "url": "https://colorado-plumbing.com/arvada-plumber#root-removal"
            }
          },
          {
            "@type": "Service",
            "name": "Hydro Jetting - Arvada",
            "serviceType": "Plumbing Service",
            "description": "High-pressure hydro jetting service in Arvada to remove years of buildup, grease, and debris. $695 flat rate with specialized equipment.",
            "provider": { "@id": "https://colorado-plumbing.com/" },
            "areaServed": { "@type": "City", "name": "Arvada" },
            "offers": {
              "@type": "Offer",
              "priceCurrency": "USD",
              "price": "695",
              "availability": "https://schema.org/InStock",
              "url": "https://colorado-plumbing.com/arvada-plumber#hydro-jetting"
            }
          }
        ]
      },
      {
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question", "name": "How much does a water heater cost in Arvada?",
            "acceptedAnswer": { "@type": "Answer", "text": "A standard 40-gallon atmospheric water heater from Colorado First Plumbing costs $2,000 fully installed in Arvada. A 50-gallon model costs $2,100. This flat-rate price includes the unit, parts, labor, permit fees, and disposal of your old water heater." }
          },
          {
            "@type": "Question", "name": "How much does a sewer camera inspection cost in Arvada?",
            "acceptedAnswer": { "@type": "Answer", "text": "$175 with detailed video report. Our sewer camera inspection in Arvada includes professional diagnosis, digital video recording, and a comprehensive written report emailed to you. As Colorado's ONLY plumber showing exact prices online, we eliminate the guesswork for established Arvada homeowners." }
          },
          {
            "@type": "Question", "name": "How much does a sewer spot repair cost in Arvada?",
            "acceptedAnswer": { "@type": "Answer", "text": "$5,000 for yard repairs or $9,500 for street-side repairs. Our sewer spot repair targets the damaged section without full line replacement, saving Arvada homeowners thousands. With specialized excavation equipment and 18,000+ completed jobs, we provide precision repairs that preserve your established neighborhood's character." }
          },
          {
            "@type": "Question", "name": "How much does professional root removal cost in Arvada?",
            "acceptedAnswer": { "@type": "Answer", "text": "Professional root removal costs $495 using our root descale cutting method. For more stubborn roots, hydro jetting costs $695. These professional methods are far more effective than chemical treatments and provide longer-lasting results." }
          },
          {
            "@type": "Question", "name": "How much does hydro jetting cost in Arvada?",
            "acceptedAnswer": { "@type": "Answer", "text": "Hydro jetting costs $695. This high-pressure water cleaning removes years of buildup, grease, and debris that traditional snaking can't eliminate. With specialized equipment and 30+ years of combined team experience, we restore your Arvada drains to like-new condition." }
          },
          {
            "@type": "Question", "name": "How much is a Bradford White 40 Gallon Atmospheric Water Heater?",
            "acceptedAnswer": { "@type": "Answer", "text": "We provide and install Bradford White 40 Gallon Atmospheric Vented Water Heaters for $2,300. This includes a new thermal expansion tank, water heater drain pan, new ball valve, drip leg and permit with inspection." }
          },
          {
            "@type": "Question", "name": "How much is a Bradford White 50 Gallon Atmospheric Water Heater?",
            "acceptedAnswer": { "@type": "Answer", "text": "We provide and install Bradford White 50 Gallon Atmospheric Vented Water Heaters for $2,400. This includes a new thermal expansion tank, water heater drain pan, new ball valve, drip leg and permit with inspection." }
          }
        ]
      }
    ]
  };

  // BirdEye widget loading
  useEffect(() => {
    const loadBirdEyeWidget = () => {
      const existingScript = document.querySelector('#birdeye-widget-script');
      if (existingScript) return;

      const script = document.createElement('script');
      script.id = 'birdeye-widget-script';
      script.type = 'text/javascript';
      script.src = 'https://birdeye.com/embed/v7/172384402926614/8/9876543218815183';
      script.async = true;
      
      script.onload = () => {
        console.log('BirdEye widget loaded successfully');
      };
      
      script.onerror = () => {
        console.error('Failed to load BirdEye widget');
        const fallback = document.querySelector('#birdeye-fallback') as HTMLElement;
        if (fallback) fallback.style.display = 'block';
      };

      document.head.appendChild(script);
    };

    loadBirdEyeWidget();

    return () => {
      const script = document.querySelector('#birdeye-widget-script');
      if (script) script.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <SchemaInjector 
        schemas={[completePageSchema]}
        title="Arvada Plumber | Water Heater & Sewer Repair | Colorado First Plumbing"
        description="Your trusted Arvada plumber with transparent pricing. Get a 40-gal water heater for $2,000 or a sewer repair for $5,000. 360 Google Reviews. No hidden fees."
        canonical="https://colorado-plumbing.com/arvada-plumber"
        keywords="Arvada plumber, Arvada plumbing, water heater Arvada, sewer repair Arvada, transparent pricing plumber"
      />
      <Header />
      <main>
        {/* Hero Section - Clean Blue Orange Gradient */}
        <section className="relative pt-48 pb-16 bg-gradient-to-br from-trust-primary via-authority-navy to-action-primary text-white overflow-hidden">
          <div className="container-custom text-center relative z-10 py-16 md:py-24">
            <div className="inline-block px-4 py-2 mb-6 rounded-full bg-white/20 backdrop-blur-sm text-white font-semibold text-sm border border-white/30">
              🏆 Arvada's #1 Rated Family-Owned Plumbers
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-6 text-white">
              Arvada Plumber with Exact Online Prices | Colorado First Plumbing
            </h1>
            <p className="text-xl mb-8 text-blue-100 leading-relaxed max-w-4xl mx-auto">
              Stop guessing what a plumber in Arvada will charge. We're Colorado First Plumbing, the <strong className="text-white">ONLY licensed plumbing contractor in Colorado with <Link to="/reviews" className="text-blue-200 hover:text-blue-100 underline">360 Google Reviews</Link> showing exact prices online</strong>. For a <Link to="/water-heater-pricing" className="text-blue-200 hover:text-blue-100 underline">40-gallon water heater</Link>, you'll pay <strong className="text-white">$2,000 fully installed</strong>. No estimates, no hidden fees. Just <Link to="/pricing" className="text-blue-200 hover:text-blue-100 underline">transparent pricing</Link> from a <Link to="/meet-the-team" className="text-blue-200 hover:text-blue-100 underline">Master Plumber owned, Woman Majority Owned business</Link> with 18,000+ completed jobs since 2018.
            </p>
            
            {/* BirdEye Widget */}
            <div className="mb-8 bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20 max-w-2xl mx-auto">
              <div id="bf-revz-widget-9876543218815183" aria-label="Customer Reviews Widget"></div>
              <div id="birdeye-fallback" style={{ display: 'none' }} className="text-blue-100">
                <p>⭐⭐⭐⭐⭐ 4.8/5 • 360 Verified Reviews</p>
              </div>
            </div>
            
            {/* Primary CTAs */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              
              <Link 
                to="/pricing" 
                className="bg-gradient-to-r from-green-500 to-green-600 hover:from-green-400 hover:to-green-500 text-white px-8 py-4 rounded-full text-xl font-semibold inline-block transition-all duration-300 shadow-xl hover:shadow-2xl transform hover:scale-105"
              >
                💰 See Transparent Pricing
              </Link>
            </div>
            
            {/* Trust Signals */}
            <div className="mt-8 flex flex-wrap justify-center items-center gap-6 text-blue-100">
              <div className="flex items-center space-x-2">
                <CheckCircle className="w-6 h-6 text-green-400" />
                <span className="text-sm font-medium">Licensed Master Plumber</span>
              </div>
              <div className="flex items-center space-x-2">
                <CheckCircle className="w-6 h-6 text-green-400" />
                <span className="text-sm font-medium">Woman Majority Owned</span>
              </div>
              <div className="flex items-center space-x-2">
                <CheckCircle className="w-6 h-6 text-green-400" />
                <span className="text-sm font-medium">4.8★ (360 Reviews)</span>
              </div>
            </div>
          </div>
        </section>

        {/* Trust & Authority Section - Light Gradient */}
        <section className="py-16 bg-gradient-to-bl from-blue-900 to-blue-950 text-white overflow-hidden">
          <div className="container-custom relative z-10">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-white">
              Why Arvada Homeowners Trust Colorado First Plumbing
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center border border-white/20">
                <div className="text-4xl font-black text-yellow-400 mb-2">18,000+</div>
                <div className="text-lg font-semibold mb-1">Jobs Completed</div>
                <div className="text-sm text-blue-200">Since 2018</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center border border-white/20">
                <div className="text-4xl font-black text-green-400 mb-2">360</div>
                <div className="text-lg font-semibold mb-1">Google Reviews</div>
                <div className="text-sm text-blue-200">4.8★ Average</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center border border-white/20">
                <div className="text-4xl font-black text-blue-400 mb-2">30+</div>
                <div className="text-lg font-semibold mb-1">CO Jurisdictions</div>
                <div className="text-sm text-blue-200">Licensed in 30+ Colorado cities including Arvada, with all permits and inspections handled</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center border border-white/20">
                <div className="text-4xl font-black text-red-400 mb-2">A+</div>
                <div className="text-lg font-semibold mb-1">BBB Rating</div>
                <div className="text-sm text-blue-200">Accredited 7/15/2024</div>
              </div>
            </div>
            <div className="text-center mt-8">
                          </div>
          </div>
        </section>

        {/* Services We Offer Section - Dark Gradient */}
        <section className="py-16 bg-gradient-to-br from-blue-800 to-blue-900 overflow-hidden">
          <div className="container-custom relative z-10">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-4 text-white">
              Professional Plumbing Services in Arvada
            </h2>
            <p className="text-center text-blue-100 mb-12 max-w-3xl mx-auto">
              From emergency repairs to complete <Link to="/bathroom-kitchen-remodel" className="text-blue-200 hover:text-blue-100 underline">home remodels</Link>, we provide <Link to="/pricing" className="text-blue-200 hover:text-blue-100 underline">transparent pricing</Link> for every service
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              <Link to="/sewer-repair-replacement" className="bg-white/10 backdrop-blur-sm rounded-xl p-6 hover:bg-white/20 transition-all duration-300 border border-white/20">
                <Wrench className="w-12 h-12 text-yellow-400 mb-4" />
                <h3 className="text-xl font-bold mb-2 text-white">Sewer Repair & Replacement</h3>
                <p className="text-blue-100">Expert sewer line services with exact pricing. Spot repairs from $5,000.</p>
              </Link>
              <Link to="/water-heater-pricing" className="bg-white/10 backdrop-blur-sm rounded-xl p-6 hover:bg-white/20 transition-all duration-300 border border-white/20">
                <Droplet className="w-12 h-12 text-blue-400 mb-4" />
                <h3 className="text-xl font-bold mb-2 text-white">Water Heater Replacement</h3>
                <p className="text-blue-100">40-gallon $2,000, 50-gallon $2,100. Summer special pricing!</p>
              </Link>
              <Link to="/sewer-cleaning-pricing" className="bg-white/10 backdrop-blur-sm rounded-xl p-6 hover:bg-white/20 transition-all duration-300 border border-white/20">
                <Shield className="w-12 h-12 text-green-400 mb-4" />
                <h3 className="text-xl font-bold mb-2 text-white">Sewer Cleaning & Maintenance</h3>
                <p className="text-blue-100">Camera scopes $175, hydro jetting $695.</p>
              </Link>
              <Link to="/tankless-water-heater" className="bg-white/10 backdrop-blur-sm rounded-xl p-6 hover:bg-white/20 transition-all duration-300 border border-white/20">
                <Zap className="w-12 h-12 text-orange-400 mb-4" />
                <h3 className="text-xl font-bold mb-2 text-white">Tankless Water Heater</h3>
                <p className="text-blue-100">Replacement $5,000, new installation $8,000.</p>
              </Link>
              <Link to="/bathroom-kitchen-remodel" className="bg-white/10 backdrop-blur-sm rounded-xl p-6 hover:bg-white/20 transition-all duration-300 border border-white/20">
                <Home className="w-12 h-12 text-purple-400 mb-4" />
                <h3 className="text-xl font-bold mb-2 text-white">Remodel & Renovation</h3>
                <p className="text-blue-100">Complete plumbing for kitchen and bathroom remodels.</p>
              </Link>
              <Link to="/custom-home-plumbing" className="bg-white/10 backdrop-blur-sm rounded-xl p-6 hover:bg-white/20 transition-all duration-300 border border-white/20">
                <Home className="w-12 h-12 text-red-400 mb-4" />
                <h3 className="text-xl font-bold mb-2 text-white">Custom Home Plumbing</h3>
                <p className="text-blue-100">New construction plumbing from foundation to finish.</p>
              </Link>
              <Link to="/commercial-plumbing" className="bg-white/10 backdrop-blur-sm rounded-xl p-6 hover:bg-white/20 transition-all duration-300 border border-white/20">
                <Users className="w-12 h-12 text-indigo-400 mb-4" />
                <h3 className="text-xl font-bold mb-2 text-white">Commercial Plumbing</h3>
                <p className="text-blue-100">Licensed commercial plumbing services for businesses.</p>
              </Link>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                <CheckCircle className="w-12 h-12 text-teal-400 mb-4" />
                <h3 className="text-xl font-bold mb-2 text-white">Much More</h3>
                <p className="text-blue-100">Garbage disposals, faucets, and all plumbing needs.</p>
              </div>
            </div>
          </div>
        </section>

        {/* What Makes Us Different Section - Light Gradient */}
        <section className="py-16 bg-gradient-to-bl from-blue-900 to-blue-950 overflow-hidden">
          <div className="container-custom relative z-10">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-white">
              What Makes Our Company Different from Other Plumbers in Arvada?
            </h2>
            <div className="max-w-4xl mx-auto bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20">
              <p className="text-xl mb-6 text-white font-semibold">
                We are the only Licensed Plumbing Contractor that shows actual prices online. Flat rate pricing for <Link to="/sewer-repair-replacement" className="text-blue-200 hover:text-blue-100 underline">sewer repair and replacement</Link>, <Link to="/water-heater-pricing" className="text-blue-200 hover:text-blue-100 underline">water heater replacement</Link>, <Link to="/tankless-water-heater-pricing" className="text-blue-200 hover:text-blue-100 underline">tankless water heater installation</Link>, <Link to="/sewer-cleaning-pricing" className="text-blue-200 hover:text-blue-100 underline">sewer cleaning and maintenance</Link>, and much much more.
              </p>
              <p className="text-lg mb-6 text-blue-100">
                We believe you deserve to know the cost before you commit. We don't employ salespeople; we employ expert plumbers. Our transparent pricing model eliminates the need for high-pressure tactics.
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
                <div className="bg-white/5 rounded-lg p-6 border border-white/10">
                  <h3 className="text-xl font-bold mb-3 text-yellow-400">Example: Sewer Repair</h3>
                  <p className="text-blue-100">
                    Wondering about the cost of <Link to="/sewer-replacement-spot-repair-pricing" className="text-blue-200 hover:text-blue-100 underline">sewer repair</Link>? At Colorado First Plumbing, a standard sewer spot repair in your yard costs <strong className="text-white">$5,000</strong>. We publish our <Link to="/pricing" className="text-blue-200 hover:text-blue-100 underline">exact prices online</Link> so you can make an informed decision without a high-pressure sales call.
                  </p>
                </div>
                <div className="bg-white/5 rounded-lg p-6 border border-white/10">
                  <h3 className="text-xl font-bold mb-3 text-green-400">Example: Water Heater</h3>
                  <p className="text-blue-100">
                    Stop guessing what a plumber in Arvada will charge. For a <Link to="/water-heater-pricing" className="text-blue-200 hover:text-blue-100 underline">40-gallon water heater</Link>, you'll pay <strong className="text-white">$2,000 fully installed</strong>. No estimates, no hidden fees. Just <Link to="/pricing" className="text-blue-200 hover:text-blue-100 underline">transparent pricing</Link> backed by <Link to="/reviews" className="text-blue-200 hover:text-blue-100 underline">360 Google Reviews</Link>.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ Section 1-5 - Alternating Gradients */}
        {/* FAQ 1: Sewer Line Responsibility - Dark Gradient */}
        <section className="py-16 bg-gradient-to-br from-blue-800 to-blue-900 overflow-hidden">
          <div className="container-custom max-w-4xl relative z-10">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">
              Who is responsible for sewer line maintenance and repairs in Arvada, CO?
            </h2>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20">
              <p className="text-lg mb-6 text-blue-100">
                In Arvada, the homeowner is responsible for the maintenance and care of the sanitary sewer service lines from their home up to and including the connection to the City's main sewer line. The City of Arvada does not cut, clean, or replace the residential portion of sewer service lines. For <Link to="/residential-plumbing" className="text-blue-200 hover:text-blue-100 underline">residential plumbing services</Link>, homeowners need professional plumbers like Colorado First Plumbing.
              </p>
              <img 
                src="/page-specific-content/arvada-plumber/arvada-sewer-excavator-replacement.jpg" 
                alt="Professional sewer line excavation and replacement in Arvada, Colorado by Colorado First Plumbing - homeowner responsibility demonstration"
                className="w-full rounded-lg mb-6 shadow-lg"
                loading="lazy"
                onError={(e) => {
                  e.currentTarget.src = '/page-specific-content/arvada-plumber/arvada-thermal-camera-leak-detection.JPEG';
                }}
              />
              <Link to="/sewer-repair-replacement" className="text-yellow-400 hover:text-yellow-300 font-semibold text-lg inline-flex items-center mb-6">
                Learn more about our sewer line repair services <CheckCircle className="w-5 h-5 ml-2" />
              </Link>
              
              {/* Integrated Pricing Question */}
              <div className="mt-8 bg-white/5 rounded-lg p-6 border border-white/10">
                <h3 className="text-xl font-bold mb-4 text-yellow-400">How much does a sewer spot repair cost in Arvada?</h3>
                <p className="text-blue-100">
                  <strong className="text-white">$5,000 for yard repairs</strong> or <strong className="text-white">$9,500 for street-side repairs</strong>. Our sewer spot repair targets the damaged section without full line replacement, saving Arvada homeowners thousands. With specialized excavation equipment and 18,000+ completed jobs, we provide precision repairs that preserve your established neighborhood's character.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ 2: Tree Root Signs - Light Gradient */}
        <section className="py-16 bg-gradient-to-bl from-blue-900 to-blue-950 overflow-hidden">
          <div className="container-custom max-w-4xl relative z-10">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">
              What are common signs of tree root intrusion in sewer lines?
            </h2>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20">
              <p className="text-lg mb-4 text-blue-100">
                Common signs of tree root intrusion include:
              </p>
              <ul className="list-disc list-inside mb-6 text-blue-100 space-y-2">
                <li>Gurgling sounds from drains</li>
                <li>Slow draining sinks and showers</li>
                <li>Frequent clogs</li>
                <li>Plumbing fixtures that cannot be unclogged</li>
                <li>Wet spots in your yard (severe cases)</li>
                <li>Foundation issues (severe cases)</li>
              </ul>
              <Link to="/sewer-cleaning-pricing" className="text-green-400 hover:text-green-300 font-semibold text-lg inline-flex items-center mb-6">
                Learn more about our sewer root cleaning pricing <CheckCircle className="w-5 h-5 ml-2" />
              </Link>
              
              {/* Integrated Pricing Question */}
              <div className="mt-8 bg-white/5 rounded-lg p-6 border border-white/10">
                <h3 className="text-xl font-bold mb-4 text-green-400">How much does a sewer camera inspection cost in Arvada?</h3>
                <p className="text-blue-100">
                  <strong className="text-white">$175 with detailed video report</strong>. Our sewer camera inspection in Arvada includes professional diagnosis, digital video recording, and a comprehensive written report emailed to you. As Colorado's ONLY plumber showing exact prices online, we eliminate the guesswork for established Arvada homeowners.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ 3: Tree Root Killers - Dark Gradient */}
        <section className="py-16 bg-gradient-to-br from-blue-800 to-blue-900 overflow-hidden">
          <div className="container-custom max-w-4xl relative z-10">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">
              Do tree root killers effectively clear clogged sewer lines caused by roots?
            </h2>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20">
              <p className="text-lg mb-4 text-blue-100">
                The effectiveness of tree root killers depends on several factors:
              </p>
              <ul className="list-disc list-inside mb-6 text-blue-100 space-y-2">
                <li>Type of tree</li>
                <li>Extent of root infiltration</li>
                <li>Application method</li>
              </ul>
              <p className="text-blue-100 mb-6">
                While they might succeed with minor encroachments, extensive root networks may require repeated applications or additional interventions. For persistent or severe issues, consulting a professional plumber is advisable.
              </p>
              
              {/* Integrated Pricing Question */}
              <div className="mt-8 bg-white/5 rounded-lg p-6 border border-white/10">
                <h3 className="text-xl font-bold mb-4 text-orange-400">How much does professional root removal cost in Arvada?</h3>
                <p className="text-blue-100">
                  Professional root removal costs <strong className="text-white">$695</strong> using our root descale cutting method. For more stubborn roots, hydro jetting costs <strong className="text-white">$695</strong>. These professional methods are far more effective than chemical treatments and provide longer-lasting results.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ 4: Professional Root Removal - Light Gradient */}
        <section className="py-16 bg-gradient-to-bl from-blue-900 to-blue-950 overflow-hidden">
          <div className="container-custom max-w-4xl relative z-10">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">
              What professional methods are used to remove tree roots from sewer lines?
            </h2>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20">
              <p className="text-lg mb-4 text-blue-100">
                Professional plumbers use several methods:
              </p>
              <div className="space-y-4 mb-6">
                <div className="bg-white/5 rounded-lg p-4 border border-white/10">
                  <h4 className="font-bold text-yellow-400 mb-2">Hydro Jetting</h4>
                  <p className="text-blue-100">High-pressure water jet to dislodge and flush out roots, debris, and obstructions</p>
                </div>
                <div className="bg-white/5 rounded-lg p-4 border border-white/10">
                  <h4 className="font-bold text-green-400 mb-2">Root Descale Cutting</h4>
                  <p className="text-blue-100">Cutting out roots with specialized equipment</p>
                </div>
                <div className="bg-white/5 rounded-lg p-4 border border-white/10">
                  <h4 className="font-bold text-orange-400 mb-2">Pipe Replacement</h4>
                  <p className="text-blue-100">For severe cases requiring spot repair or full replacement</p>
                </div>
                <div className="bg-white/5 rounded-lg p-4 border border-white/10">
                  <h4 className="font-bold text-blue-400 mb-2">Root Foam Treatment</h4>
                  <p className="text-blue-100">Applied every 2-3 years after cutting roots to postpone line replacement or lining for 5-10 years</p>
                </div>
              </div>
              <Link to="/root-removal-pricing" className="text-yellow-400 hover:text-yellow-300 font-semibold text-lg inline-flex items-center mb-6">
                See our Root Removal Descale method and Pricing <CheckCircle className="w-5 h-5 ml-2" />
              </Link>
              
              {/* Integrated Pricing Question */}
              <div className="mt-8 bg-white/5 rounded-lg p-6 border border-white/10">
                <h3 className="text-xl font-bold mb-4 text-red-400">How much does hydro jetting cost in Arvada?</h3>
                <p className="text-blue-100">
                  <Link to="/hydro-jetting-pricing" className="text-blue-200 hover:text-blue-100 underline">Hydro jetting costs <strong className="text-white">$695</strong></Link>. This high-pressure water cleaning removes years of buildup, grease, and debris that traditional <Link to="/sewer-snake-auger-pricing" className="text-blue-200 hover:text-blue-100 underline">snaking</Link> can't eliminate. With specialized equipment and 30+ years of combined team experience, we restore your Arvada drains to like-new condition.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ 5: CIPP Lining - Dark Gradient */}
        <section className="py-16 bg-gradient-to-br from-blue-800 to-blue-900 overflow-hidden">
          <div className="container-custom max-w-4xl relative z-10">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">
              What is Cured-In-Place Pipe (CIPP) lining, and when is it used for sewer line repair in Arvada?
            </h2>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20">
              <p className="text-lg mb-6 text-blue-100">
                <strong className="text-white">CIPP lining</strong> is a trenchless rehabilitation method used to repair existing pipelines without extensive digging. The process involves:
              </p>
              <ul className="list-disc list-inside mb-6 text-blue-100 space-y-2">
                <li>Applying an epoxy liner to the inside of the damaged pipe</li>
                <li>The liner hardens to form a new pipeline</li>
                <li>Seals openings and prevents future root intrusion</li>
              </ul>
              <p className="text-blue-100 mb-6">
                This method can be a permanent solution, especially for clay or cast iron pipes with root issues, and can save homeowners from tearing up concrete. The City of Denver's Sanitary Sewer Design Technical Criteria Manual lists flexible non-shear reinforced couplings (ASTM C1173) as acceptable service connection methods.
              </p>
              
              {/* Integrated Pricing Question */}
              <div className="mt-8 bg-white/5 rounded-lg p-6 border border-white/10">
                <h3 className="text-xl font-bold mb-4 text-purple-400">What are the alternatives to pipe lining and their costs?</h3>
                <p className="text-blue-100">
                  While CIPP lining is effective, Colorado First Plumbing specializes in traditional repairs with transparent pricing: <strong className="text-white">$5,000 for yard spot repairs</strong>, <strong className="text-white">$9,500 for street repairs</strong>, and <strong className="text-white">$12,000 for full sewer replacement</strong>. We provide honest assessments of whether repair or replacement is most cost-effective for your situation.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ 6-10 Continue with alternating gradients... */}
        {/* FAQ 6: Permits for Sewer Work - Light Gradient */}
        <section className="py-16 bg-gradient-to-bl from-blue-900 to-blue-950 overflow-hidden">
          <div className="container-custom max-w-4xl relative z-10">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">
              Are permits required for sewer line replacement in Arvada, CO?
            </h2>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20">
              <p className="text-lg mb-6 text-blue-100">
                <strong className="text-white">Yes</strong>, most types of plumbing work, including major installations and renovations like sewer line replacement, typically require a permit in Denver and surrounding areas like Arvada. Homeowners in Arvada wishing to perform repairs entirely on private property still need a permit. Obtaining appropriate permits ensures:
              </p>
              <ul className="list-disc list-inside mb-6 text-blue-100 space-y-2">
                <li>Compliance with building codes</li>
                <li>Safety standards</li>
                <li>Protection against future legal and insurance issues</li>
              </ul>
              <img 
                src="/page-specific-content/arvada-plumber/arvada-codee-jessen-sewer-spot-repair-yard.jpg" 
                alt="Master Plumber Codee Jessen performing permitted sewer spot repair in Arvada yard - proper permitting process"
                className="w-full rounded-lg mb-6 shadow-lg"
                loading="lazy"
                onError={(e) => {
                  e.currentTarget.src = '/page-specific-content/arvada-plumber/arvada-underground-inspection-prep.jpg';
                }}
              />
              
              {/* Integrated Pricing Question */}
              <div className="mt-8 bg-white/5 rounded-lg p-6 border border-white/10">
                <h3 className="text-xl font-bold mb-4 text-indigo-400">Are permits included in your sewer repair pricing?</h3>
                <p className="text-blue-100">
                  Yes, all necessary permits are included in our flat-rate pricing. Our <Link to="/sewer-replacement-spot-repair-pricing" className="text-blue-200 hover:text-blue-100 underline"><strong className="text-white">$5,000 yard spot repair</strong>, <strong className="text-white">$9,500 street repair</strong>, and <strong className="text-white">$12,000 full replacement</strong></Link> prices include permit fees, inspections, and all required documentation. We handle the entire permit process for you.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ 7: Sewer Line Depth - Dark Gradient */}
        <section className="py-16 bg-gradient-to-br from-blue-800 to-blue-900 overflow-hidden">
          <div className="container-custom max-w-4xl relative z-10">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">
              How deep are sewer lines typically buried in cold climates like Colorado?
            </h2>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20">
              <p className="text-lg mb-6 text-blue-100">
                Sewer lines in cold climates need to be buried deeper than in warm climates to prevent freezing:
              </p>
              <ul className="list-disc list-inside mb-6 text-blue-100 space-y-2">
                <li><strong className="text-white">General rule</strong>: Trench should be about two feet deeper than the area's frost line</li>
                <li><strong className="text-white">Commercial installations</strong>: Typically 4 to 12 feet deep</li>
                <li><strong className="text-white">Arvada specific</strong>: City of Denver's manual indicates force mains need minimum depth of 4.5 feet to prevent freezing</li>
              </ul>
              <img 
                src="/page-specific-content/arvada-plumber/arvada-locate-sewer-in-street.jpg" 
                alt="Locating sewer line depth in Arvada street - Colorado frost line burial requirements demonstration"
                className="w-full rounded-lg mb-6 shadow-lg"
                loading="lazy"
                onError={(e) => {
                  e.currentTarget.src = '/page-specific-content/arvada-plumber/arvada-underground-inspection-prep.jpg';
                }}
              />
              
              {/* Integrated Pricing Question */}
              <div className="mt-8 bg-white/5 rounded-lg p-6 border border-white/10">
                <h3 className="text-xl font-bold mb-4 text-cyan-400">Does depth affect sewer repair pricing?</h3>
                <p className="text-blue-100">
                  Our standard pricing (<strong className="text-white">$5,000 yard</strong>, <strong className="text-white">$9,500 street</strong>) covers typical depths up to 8 feet. Deeper excavations may require additional equipment and safety measures. We'll provide exact pricing after our <strong className="text-white">$175 camera inspection</strong> determines the depth and scope of work needed.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ 8: Fernco Couplings - Light Gradient */}
        <section className="py-16 bg-gradient-to-bl from-blue-900 to-blue-950 overflow-hidden">
          <div className="container-custom max-w-4xl relative z-10">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">
              What are "strong back" or shielded Fernco couplings, and when should they be used?
            </h2>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20">
              <p className="text-lg mb-6 text-blue-100">
                <strong className="text-white">Strong back or shielded Fernco couplings</strong> are flexible couplings designed for:
              </p>
              <ul className="list-disc list-inside mb-6 text-blue-100 space-y-2">
                <li>Resistance to heavy earth loads and shear forces</li>
                <li>Improved pipe alignment</li>
                <li>Leak-proof connections</li>
                <li>Meeting ASTM C 1173 standards</li>
              </ul>
              <p className="text-blue-100 mb-6">
                Unlike regular Fernco couplings, shielded couplings are recommended for underground use, especially in concrete, to prevent sagging and pinching.
              </p>
              
              {/* Integrated Pricing Question */}
              <div className="mt-8 bg-white/5 rounded-lg p-6 border border-white/10">
                <h3 className="text-xl font-bold mb-4 text-emerald-400">Are quality couplings included in your repair pricing?</h3>
                <p className="text-blue-100">
                  Yes, our sewer repair prices include all professional-grade materials. Whether it's a <strong className="text-white">$5,000 yard spot repair</strong> or <strong className="text-white">$12,000 full replacement</strong>, we use only code-approved, shielded couplings and fittings that meet or exceed local standards. No corners cut, no cheap materials.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ 9: Plumbing Cleanouts - Dark Gradient */}
        <section className="py-16 bg-gradient-to-br from-blue-800 to-blue-900 overflow-hidden">
          <div className="container-custom max-w-4xl relative z-10">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">
              What are plumbing cleanouts, and why are they important for Arvada homeowners?
            </h2>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20">
              <p className="text-lg mb-6 text-blue-100">
                A <strong className="text-white">plumbing cleanout</strong> is a capped pipe that connects to your sewer or drainage lines, allowing easy access for cleaning or inspection. Types include:
              </p>
              <ul className="list-disc list-inside mb-6 text-blue-100 space-y-2">
                <li><strong className="text-white">One-way cleanouts</strong>: Access in one direction</li>
                <li><strong className="text-white">Two-way cleanouts</strong>: Access in both directions for easier maintenance</li>
              </ul>
              <p className="text-blue-100 mb-6">
                In Arvada, cleanouts are imperative because they enable proper pipe cleaning and prevent frequent clogs, especially when systems are buried under slabs or in yards.
              </p>
              
              {/* Integrated Pricing Question */}
              <div className="mt-8 bg-white/5 rounded-lg p-6 border border-white/10">
                <h3 className="text-xl font-bold mb-4 text-lime-400">How much does it cost to install a cleanout?</h3>
                <p className="text-blue-100">
                  Cleanout installation is often included in our repair services. For standalone installation, pricing varies based on location and accessibility. Our <strong className="text-white">$175 camera inspection</strong> can determine if you need additional cleanouts, and we'll provide exact pricing for your specific situation.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ 10: Water Heater Permits - Light Gradient */}
        <section className="py-16 bg-gradient-to-bl from-blue-900 to-blue-950 overflow-hidden">
          <div className="container-custom max-w-4xl relative z-10">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">
              Are permits required for water heater replacement in Arvada, CO?
            </h2>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20">
              <p className="text-lg mb-6 text-blue-100">
                <strong className="text-white">Yes</strong>, water heater installations require permits in Denver and surrounding areas. In Arvada:
              </p>
              <ul className="list-disc list-inside mb-6 text-blue-100 space-y-2">
                <li>Specific residential plumbing permits are required for water heater replacements</li>
                <li>If electrical work beyond simple disconnect/reconnect is needed, a Final Electrical Inspection must be scheduled</li>
                <li>Applications can be submitted to the Building Inspection Division in City Hall</li>
              </ul>
              <Link to="/water-heater-pricing" className="text-yellow-400 hover:text-yellow-300 font-semibold text-lg inline-flex items-center mb-6">
                See our Water Heater Flat Rate Pricing <CheckCircle className="w-5 h-5 ml-2" />
              </Link>
              
              {/* Integrated Pricing Question */}
              <div className="mt-8 bg-white/5 rounded-lg p-6 border border-white/10">
                <h3 className="text-xl font-bold mb-4 text-pink-400">How much is a 40 gallon water heater in Arvada?</h3>
                <p className="text-blue-100">
                  <Link to="/flat-rate-affordable-rheem-water-heaters-in-colorado" className="text-blue-200 hover:text-blue-100 underline"><strong className="text-white">$2,000 fully installed</strong></Link> (Special Deal price - Regular $2,425). This is our out-the-door price and includes the Rheem/AO Smith unit, all parts, permits, and professional installation by our <Link to="/team/codee-jessen" className="text-blue-200 hover:text-blue-100 underline">Colorado licensed Master Plumber team</Link>. With 18,000+ water heater installations completed since 2018, we're the trusted choice for Arvada families.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ 11-15 Continue... */}
        {/* FAQ 11: Expansion Tank Requirements - Dark Gradient */}
        <section className="py-16 bg-gradient-to-br from-blue-800 to-blue-900 overflow-hidden">
          <div className="container-custom max-w-4xl relative z-10">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">
              Is a water heater expansion tank required in Arvada, CO?
            </h2>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20">
              <p className="text-lg mb-6 text-blue-100">
                <strong className="text-white">Yes</strong>, by Colorado law, an expansion tank is required when a home has:
              </p>
              <ul className="list-disc list-inside mb-6 text-blue-100 space-y-2">
                <li>A backflow preventer on the water main</li>
                <li>A check valve in the plumbing system</li>
              </ul>
              <p className="text-lg mb-6 text-blue-100">
                <strong className="text-white">Water heater expansion tanks</strong> (thermal expansion tanks) help:
              </p>
              <ul className="list-disc list-inside mb-6 text-blue-100 space-y-2">
                <li>Regulate pressure in water heaters and plumbing systems</li>
                <li>Accommodate thermal expansion of heated water</li>
                <li>Prevent accidental water discharge through temperature and pressure relief valves</li>
              </ul>
              <img 
                src="/page-specific-content/arvada-plumber/arvada-ao-smith-40-gallon-replacement-with-thermal-tank.jpg" 
                alt="AO Smith 40 gallon water heater installation with required thermal expansion tank in Arvada home - Colorado law compliance"
                className="w-full rounded-lg mb-6 shadow-lg"
                loading="lazy"
                onError={(e) => {
                  e.currentTarget.src = '/page-specific-content/arvada-plumber/arvada-basement-install-underground-plumbing.jpg';
                }}
              />
              <Link to="/flat-rate-affordable-rheem-water-heaters-in-colorado" className="text-orange-400 hover:text-orange-300 font-semibold text-lg inline-flex items-center mb-6">
                Check out our Water Heater Summer Special Pricing <CheckCircle className="w-5 h-5 ml-2" />
              </Link>
              
              {/* Integrated Pricing Question */}
              <div className="mt-8 bg-white/5 rounded-lg p-6 border border-white/10">
                <h3 className="text-xl font-bold mb-4 text-amber-400">Is the expansion tank included in your water heater price?</h3>
                <p className="text-blue-100">
                  Yes! Our <Link to="/water-heater-pricing" className="text-blue-200 hover:text-blue-100 underline">water heater prices</Link> (<Link to="/flat-rate-affordable-rheem-water-heaters-in-colorado" className="text-blue-200 hover:text-blue-100 underline"><strong className="text-white">$2,000 for 40-gallon</strong>, <strong className="text-white">$2,100 for 50-gallon</strong></Link> during Special Deal) include the thermal expansion tank, drain pan, and all code-required components. No surprises, no add-ons - everything needed for a complete, code-compliant installation.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ 12: Who Can Install - Light Gradient */}
        <section className="py-16 bg-gradient-to-bl from-blue-900 to-blue-950 overflow-hidden">
          <div className="container-custom max-w-4xl relative z-10">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">
              Who can install water heaters and expansion tanks in Arvada?
            </h2>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20">
              <p className="text-lg mb-6 text-blue-100">
                For major plumbing projects like water heater installations:
              </p>
              <ul className="list-disc list-inside mb-6 text-blue-100 space-y-2">
                <li><strong className="text-white">Recommended</strong>: Licensed professionals familiar with state and city codes</li>
                <li><strong className="text-white">Licensed plumbers</strong> ensure compliance, accurate tank sizing, proper air pressure setting, and correct installation</li>
                <li><strong className="text-white">Contractors</strong> need an active license with the City of Arvada</li>
                <li><strong className="text-white">Homeowners</strong> can apply for permits for appliance installations</li>
              </ul>
              <p className="text-blue-100 mb-6">
                Hiring a licensed plumber is crucial for proper installation and code compliance.
              </p>
              
              {/* Integrated Pricing Question */}
              <div className="mt-8 bg-white/5 rounded-lg p-6 border border-white/10">
                <h3 className="text-xl font-bold mb-4 text-violet-400">How much is a 50 gallon water heater replacement in Arvada?</h3>
                <p className="text-blue-100">
                  <strong className="text-white">$2,100 fully installed</strong> (Summer Special price - Regular $2,525). Perfect for larger Arvada families, our 50-gallon units provide enhanced hot water capacity with the same transparent pricing and professional installation. Michelle Jessen (Woman Majority Owner) and Master Plumber Codee Jessen ensure every installation meets today's IPC code standards.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ 13: Gas Line Permits - Dark Gradient */}
        <section className="py-16 bg-gradient-to-br from-blue-800 to-blue-900 overflow-hidden">
          <div className="container-custom max-w-4xl relative z-10">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">
              Are permits and inspections necessary for gas line installation or modification in Arvada?
            </h2>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20">
              <p className="text-lg mb-6 text-blue-100">
                <strong className="text-white">Yes</strong>, installing or modifying gas lines in Colorado requires:
              </p>
              <ul className="list-disc list-inside mb-6 text-blue-100 space-y-2">
                <li>Meeting strict safety standards</li>
                <li>Complying with local codes</li>
                <li>Obtaining appropriate gas line permits and inspections</li>
              </ul>
              <img 
                src="/page-specific-content/arvada-plumber/arvada-gas-megapress-replace.jpg" 
                alt="Professional gas line installation using MegaPress fittings in Arvada ceiling"
                className="w-full rounded-lg mb-6 shadow-lg"
                loading="lazy"
              />
              <p className="text-lg mb-6 text-blue-100">
                <strong className="text-white">Arvada requirements</strong>:
              </p>
              <ul className="list-disc list-inside mb-6 text-blue-100 space-y-2">
                <li>Underground gas lines: minimum 12 inches depth (8 inches for individual appliance lines)</li>
                <li>Inspection required before backfilling</li>
                <li>Gas line inspection required for residential interior remodels</li>
              </ul>
              
              {/* Integrated Pricing Question */}
              <div className="mt-8 bg-white/5 rounded-lg p-6 border border-white/10">
                <h3 className="text-xl font-bold mb-4 text-sky-400">Are gas line permits included in water heater installation?</h3>
                <p className="text-blue-100">
                  Yes, all necessary gas line work and permits are included in our water heater installation prices (<strong className="text-white">$2,000 for 40-gallon</strong>, <strong className="text-white">$2,100 for 50-gallon</strong>). We handle all code compliance, inspections, and use professional-grade MegaPressG fittings for safe, reliable connections.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ 14: Gas Line Pressure Testing - Light Gradient */}
        <section className="py-16 bg-gradient-to-bl from-blue-900 to-blue-950 overflow-hidden">
          <div className="container-custom max-w-4xl relative z-10">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">
              What is the required pressure test for gas lines in Arvada, CO?
            </h2>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20">
              <p className="text-lg mb-6 text-blue-100">
                <strong className="text-white">Arvada requirement</strong>: Minimum 10 psi for 15 minutes
              </p>
              <p className="text-blue-100 mb-6">
                This exceeds the International Fuel Gas Code minimum (3 psig) and aligns with Colorado gas supplier requirements. Testing above maximum pressure rating of components should be avoided.
              </p>
              <img 
                src="/page-specific-content/arvada-plumber/arvada-gas-inspection-gauge.jpg" 
                alt="Gas line pressure testing gauge showing proper inspection levels in Arvada"
                className="w-full rounded-lg mb-6 shadow-lg"
                loading="lazy"
              />
              
              {/* Integrated Pricing Question */}
              <div className="mt-8 bg-white/5 rounded-lg p-6 border border-white/10">
                <h3 className="text-xl font-bold mb-4 text-teal-400">Is gas line testing included in your service?</h3>
                <p className="text-blue-100">
                  Yes, proper gas line pressure testing is included in all our gas-related services. Whether installing a <strong className="text-white">$2,000 water heater</strong> or a <strong className="text-white">$5,000 tankless replacement</strong>, we perform all required pressure tests and provide documentation for city inspections.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ 15: Gas Fittings - Dark Gradient */}
        <section className="py-16 bg-gradient-to-br from-blue-800 to-blue-900 overflow-hidden">
          <div className="container-custom max-w-4xl relative z-10">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">
              What types of fittings are approved for gas line installations in Arvada?
            </h2>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20">
              <p className="text-lg mb-6 text-blue-100">
                <strong className="text-white">Viega MegaPressG fittings</strong> are approved for:
              </p>
              <ul className="list-disc list-inside mb-6 text-blue-100 space-y-2">
                <li>Gas and fuel oil applications</li>
                <li>Schedule 5 to Schedule 40 carbon steel pipe</li>
                <li>Underground applications (per code and local AHJ)</li>
                <li>Pipe sizes from ½ inch to 4 inches</li>
                <li>Use HNBR sealing element for fuels and gases</li>
              </ul>
              <p className="text-lg mb-6 text-blue-100">
                <strong className="text-white">Additional requirements</strong>:
              </p>
              <ul className="list-disc list-inside mb-6 text-blue-100 space-y-2">
                <li>Underground non-metallic gas piping must include yellow 18-gauge tracer wire</li>
                <li>Protection against corrosion required</li>
              </ul>
              
              {/* Integrated Pricing Question */}
              <div className="mt-8 bg-white/5 rounded-lg p-6 border border-white/10">
                <h3 className="text-xl font-bold mb-4 text-rose-400">Do you use professional-grade fittings?</h3>
                <p className="text-blue-100">
                  Absolutely. All our installations use code-approved, professional-grade fittings like MegaPressG. This quality is built into our transparent pricing - <strong className="text-white">$2,000 for 40-gallon water heaters</strong>, <strong className="text-white">$5,000 for tankless replacements</strong>. No cheap materials, no shortcuts, just professional work that passes inspection every time.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ 16-20 Continue... */}
        {/* FAQ 16: Underground Pipe Damage - Light Gradient */}
        <section className="py-16 bg-gradient-to-bl from-blue-900 to-blue-950 overflow-hidden">
          <div className="container-custom max-w-4xl relative z-10">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">
              What are the common causes of damage to underground pipes?
            </h2>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20">
              <p className="text-lg mb-4 text-blue-100">
                Common causes include:
              </p>
              <ul className="list-disc list-inside mb-6 text-blue-100 space-y-2">
                <li><strong className="text-white">Tree root infiltration</strong></li>
                <li><strong className="text-white">Aging infrastructure</strong></li>
                <li><strong className="text-white">Corrosion</strong></li>
              </ul>
              <p className="text-lg mb-4 text-blue-100">
                These factors lead to:
              </p>
              <ul className="list-disc list-inside mb-6 text-blue-100 space-y-2">
                <li>Slow or blocked drains</li>
                <li>Unpleasant odors</li>
                <li>Water stains</li>
                <li>Sinkholes or sunken yard areas</li>
              </ul>
              <img 
                src="/page-specific-content/arvada-plumber/underground-water-line-repair-in-arvada-colorado.jpg" 
                alt="Underground water line repair in Arvada, Colorado showing common pipe damage causes"
                className="w-full rounded-lg mb-6 shadow-lg"
                loading="lazy"
                onError={(e) => {
                  e.currentTarget.src = '/page-specific-content/arvada-plumber/arvada-poly-underground-water-pipe-repair-coupling.jpg';
                }}
              />
              
              {/* Integrated Pricing Question */}
              <div className="mt-8 bg-white/5 rounded-lg p-6 border border-white/10">
                <h3 className="text-xl font-bold mb-4 text-fuchsia-400">How much does underground pipe repair cost?</h3>
                <p className="text-blue-100">
                  For sewer pipes: <strong className="text-white">$5,000 for yard spot repairs</strong>, <strong className="text-white">$9,500 for street repairs</strong>, or <strong className="text-white">$12,000 for full replacement</strong>. Water line repairs vary based on material and location. Our <strong className="text-white">$175 camera inspection</strong> identifies the exact problem and location for accurate pricing.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ 17: Trenchless Methods - Dark Gradient */}
        <section className="py-16 bg-gradient-to-br from-blue-800 to-blue-900 overflow-hidden">
          <div className="container-custom max-w-4xl relative z-10">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">
              What are "trenchless" methods for repairing underground pipes?
            </h2>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20">
              <p className="text-lg mb-6 text-blue-100">
                Trenchless repair methods allow pipes to be repaired from the inside out, avoiding extensive digging:
              </p>
              
              <div className="space-y-6 mb-6">
                <div className="bg-white/5 rounded-lg p-6 border border-white/10">
                  <h3 className="text-xl font-bold mb-3 text-yellow-400">Pipe Lining (CIPP)</h3>
                  <ul className="list-disc list-inside text-blue-100 space-y-1">
                    <li>Coating old pipe with epoxy-infused liner</li>
                    <li>Liner is blown down pipe and cured</li>
                    <li>Creates new inner pipe</li>
                  </ul>
                </div>
                
                <div className="bg-white/5 rounded-lg p-6 border border-white/10">
                  <h3 className="text-xl font-bold mb-3 text-green-400">Pipe Bursting</h3>
                  <ul className="list-disc list-inside text-blue-100 space-y-1">
                    <li>Pulling new pipe through old one</li>
                    <li>Fractures old pipe outward as new one takes place</li>
                  </ul>
                </div>
              </div>
              
              <img 
                src="/page-specific-content/arvada-plumber/safe-shooring-and-dig-practices-for-sewer-excavations-in-arvada.jpg" 
                alt="Safe shoring and dig practices for sewer excavations in Arvada - traditional vs trenchless methods comparison"
                className="w-full rounded-lg mb-6 shadow-lg"
                loading="lazy"
                onError={(e) => {
                  e.currentTarget.src = '/page-specific-content/arvada-plumber/arvada-underground-inspection-prep.jpg';
                }}
              />
              
              {/* Integrated Pricing Question */}
              <div className="mt-8 bg-white/5 rounded-lg p-6 border border-white/10">
                <h3 className="text-xl font-bold mb-4 text-blue-400">How do trenchless repairs compare to traditional excavation pricing?</h3>
                <p className="text-blue-100">
                  While trenchless methods can be effective, our traditional excavation with transparent pricing often provides better long-term value: <strong className="text-white">$5,000 yard spot repair</strong>, <strong className="text-white">$9,500 street repair</strong>, or <strong className="text-white">$12,000 full replacement</strong>. We'll honestly assess which method is most cost-effective for your situation.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ 18: Underground Water Lines - Light Gradient */}
        <section className="py-16 bg-gradient-to-bl from-blue-900 to-blue-950 overflow-hidden">
          <div className="container-custom max-w-4xl relative z-10">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">
              What pipes are commonly used for underground water lines in Colorado?
            </h2>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20">
              <p className="text-lg mb-6 text-blue-100">
                <strong className="text-white">Front Range municipalities</strong> typically require:
              </p>
              <ul className="list-disc list-inside mb-6 text-blue-100 space-y-2">
                <li><strong className="text-white">Durable copper piping</strong> (majority requirement)</li>
                <li><strong className="text-white">Composite or plastic materials</strong> (some areas, to curb corrosion)</li>
              </ul>
              <p className="text-lg mb-6 text-blue-100">
                <strong className="text-white">Arvada specifics</strong>:
              </p>
              <ul className="list-disc list-inside mb-6 text-blue-100 space-y-2">
                <li>Homes built after 1950: likely copper service lines</li>
                <li><strong className="text-white">Galvanized lines</strong> (used until 1980s): City recommends replacement</li>
                <li><strong className="text-white">Lead service lines</strong> (pre-1960): City recommends replacement due to lead transmission risk</li>
                <li><strong className="text-white">Dielectric junction</strong> required when connecting copper to galvanized lines</li>
              </ul>
              
              {/* Integrated Pricing Question */}
              <div className="mt-8 bg-white/5 rounded-lg p-6 border border-white/10">
                <h3 className="text-xl font-bold mb-4 text-indigo-400">Do you replace lead and galvanized water lines?</h3>
                <p className="text-blue-100">
                  Yes, we specialize in replacing outdated and dangerous water lines. Pricing varies based on length and location, but we provide exact quotes after assessment. Our <Link to="/diagnostic-services-pricing" className="text-blue-200 hover:text-blue-100 underline"><strong className="text-white">$95 standard diagnosis</strong> or <strong className="text-white">$225 difficult diagnosis</strong></Link> can identify your pipe material and condition.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ 19: Basement Permits - Dark Gradient */}
        <section className="py-16 bg-gradient-to-br from-blue-800 to-blue-900 overflow-hidden">
          <div className="container-custom max-w-4xl relative z-10">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">
              Are permits and inspections needed for basement finish plumbing work in Arvada?
            </h2>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20">
              <p className="text-lg mb-6 text-blue-100">
                <strong className="text-white">Yes</strong>, basement finishes or new bathroom remodels require multiple permits and inspections:
              </p>
              <ul className="list-disc list-inside mb-6 text-blue-100 space-y-2">
                <li>Underground plumbing inspection</li>
                <li>Rough plumbing inspection</li>
                <li>Final plumbing inspection</li>
                <li>Gas line sizing calculation and inspection (if applicable)</li>
              </ul>
              <p className="text-blue-100 mb-6">
                The City of Arvada requires permits to ensure work meets local building codes and safety standards.
              </p>
              <img 
                src="/page-specific-content/arvada-plumber/arvada-basement-install-underground-plumbing.jpg" 
                alt="Underground plumbing installation for basement bathroom in Arvada"
                className="w-full rounded-lg mb-6 shadow-lg"
                loading="lazy"
              />
              
              {/* Integrated Pricing Question */}
              <div className="mt-8 bg-white/5 rounded-lg p-6 border border-white/10">
                <h3 className="text-xl font-bold mb-4 text-purple-400">How much does basement bathroom plumbing cost?</h3>
                <p className="text-blue-100">
                  <Link to="/bathroom-kitchen-remodel" className="text-blue-200 hover:text-blue-100 underline">Basement bathroom plumbing</Link> varies based on complexity and distance from main lines. We provide exact quotes after assessment. All our work includes permits and passes inspection. For reference, our other services include <Link to="/garbage-disposal-pricing" className="text-blue-200 hover:text-blue-100 underline"><strong className="text-white">garbage disposal installation $425-$775</strong></Link> and <Link to="/faucet-pricing" className="text-blue-200 hover:text-blue-100 underline"><strong className="text-white">kitchen faucet installation $225-$485</strong></Link>.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ 20: Second Opinions - Light Gradient */}
        <section className="py-16 bg-gradient-to-bl from-blue-900 to-blue-950 overflow-hidden">
          <div className="container-custom max-w-4xl relative z-10">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">
              How can Arvada homeowners get an unbiased second opinion on sewer line problems?
            </h2>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20">
              <p className="text-lg mb-6 text-blue-100">
                The <strong className="text-white">City of Arvada's Wastewater Division</strong> offers:
              </p>
              <ul className="list-disc list-inside mb-6 text-blue-100 space-y-2">
                <li>Review of televised video inspections</li>
                <li>Unbiased second opinion on service line problems</li>
                <li>Help avoiding potentially unnecessary repairs</li>
              </ul>
              <p className="text-blue-100 mb-6">
                <strong className="text-white">Contact</strong>: 720-898-7770 to schedule an appointment
              </p>
              
              {/* Integrated Pricing Question */}
              <div className="mt-8 bg-white/5 rounded-lg p-6 border border-white/10">
                <h3 className="text-xl font-bold mb-4 text-cyan-400">Why choose Colorado First Plumbing for honest assessments?</h3>
                <p className="text-blue-100">
                  We provide <Link to="/pricing" className="text-blue-200 hover:text-blue-100 underline">transparent pricing</Link> and honest assessments because we don't employ salespeople - only <Link to="/meet-the-team" className="text-blue-200 hover:text-blue-100 underline">expert plumbers</Link>. Our <Link to="/sewer-cleaning-pricing" className="text-blue-200 hover:text-blue-100 underline"><strong className="text-white">$175 camera inspection</strong></Link> includes a detailed video report you can share with the city or other contractors. With exact pricing online (<Link to="/sewer-replacement-spot-repair-pricing" className="text-blue-200 hover:text-blue-100 underline"><strong className="text-white">$5,000 spot repair</strong>, <strong className="text-white">$12,000 full replacement</strong></Link>), there's no incentive to oversell unnecessary repairs.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* New FAQ Section for Arvada */}
        <section className="py-16 bg-gradient-to-bl from-blue-900 to-blue-950 overflow-hidden">
          <div className="container-custom max-w-4xl relative z-10">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-white">
              Frequently Asked Questions in Arvada
            </h2>
            <div className="space-y-6">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                <h3 className="text-xl font-bold text-yellow-400 mb-3">
                  How much does a water heater cost in Arvada?
                </h3>
                <p className="text-blue-100 text-lg">
                  A standard 40-gallon atmospheric water heater from Colorado First Plumbing costs <strong>$2,000</strong> fully installed in Arvada. A 50-gallon model costs <strong>$2,100</strong>. This flat-rate price includes the unit, parts, labor, permit fees, and disposal of your old water heater.
                </p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                <h3 className="text-xl font-bold text-yellow-400 mb-3">
                  What is the cost for a sewer repair in Arvada?
                </h3>
                <p className="text-blue-100 text-lg">
                  A sewer spot repair in your yard costs a flat rate of <strong>$5,000</strong> in Arvada. If the repair is in the street, the cost is <strong>$9,500</strong>. For a full sewer line replacement, the price is <strong>$12,000</strong>. We offer a <strong>$175</strong> sewer camera inspection to diagnose the exact issue first.
                </p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                <h3 className="text-xl font-bold text-yellow-400 mb-3">
                  Who is responsible for sewer line repairs in Arvada, CO?
                </h3>
                <p className="text-blue-100 text-lg">
                  In Arvada, the homeowner is responsible for the maintenance and repair of the sewer line from the house up to and including the connection to the city's main sewer line. Colorado First Plumbing provides expert repair services for homeowners.
                </p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                <h3 className="text-xl font-bold text-yellow-400 mb-3">
                  Do I need a permit to replace my water heater in Arvada?
                </h3>
                <p className="text-blue-100 text-lg">
                  Yes, a permit is required for water heater replacements in Arvada. Colorado First Plumbing handles the entire permitting process as part of our all-inclusive installation service. The cost of the permit is included in our <strong>$2,000</strong> (40-gal) and <strong>$2,100</strong> (50-gal) flat-rate prices.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Common Plumbing Issues in Arvada Section - Dark Gradient */}
        <section className="py-16 bg-gradient-to-br from-blue-800 to-blue-900 overflow-hidden">
          <div className="container-custom relative z-10">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-white">
              Common Plumbing Issues in Arvada
            </h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                <AlertTriangle className="w-12 h-12 text-yellow-400 mb-4" />
                <h3 className="text-xl font-bold mb-3 text-white">Sewer Line Problems & Tree Roots</h3>
                <ul className="text-blue-100 space-y-2">
                  <li>• Primary threat: Tree roots targeting older clay pipes</li>
                  <li>• Vulnerable systems: Clay pipes joined with mortar</li>
                  <li>• Signs: Gurgling drains, slow drainage, frequent clogs</li>
                </ul>
                <p className="mt-4 text-yellow-300 font-semibold">Our Solution: $175 camera inspection, $695 root removal</p>
              </div>
              
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                <AlertTriangle className="w-12 h-12 text-orange-400 mb-4" />
                <h3 className="text-xl font-bold mb-3 text-white">Cast Iron Pipes</h3>
                <ul className="text-blue-100 space-y-2">
                  <li>• Issue: Disintegration or rot over time in older homes</li>
                  <li>• Solution: Often requires complete replacement</li>
                </ul>
                <img 
                  src="/page-specific-content/arvada-plumber/cast-iron-pipe-replacement-in-arvada.jpg" 
                  alt="Cast iron pipe replacement in Arvada Colorado showing deteriorated pipe condition"
                  className="w-full rounded-lg my-4 shadow-lg"
                  loading="lazy"
                />
                <p className="mt-4 text-orange-300 font-semibold">Our Solution: <Link to="/cast-iron-descaling-pricing" className="text-orange-200 hover:text-orange-100 underline">Cast iron descaling</Link>, <Link to="/sewer-replacement-spot-repair-pricing" className="text-orange-200 hover:text-orange-100 underline">$5,000 spot repair or $12,000 full replacement</Link></p>
              </div>
              
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                <AlertTriangle className="w-12 h-12 text-red-400 mb-4" />
                <h3 className="text-xl font-bold mb-3 text-white">Galvanized & Lead Service Lines</h3>
                <ul className="text-blue-100 space-y-2">
                  <li>• City policy: Arvada prohibits lead and pre-1960 galvanized lines</li>
                  <li>• Action: City offers free replacement through 2026</li>
                  <li>• Health concern: Potential lead transmission</li>
                </ul>
                <p className="mt-4 text-red-300 font-semibold">We work with city programs for safe replacements</p>
              </div>
              
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                <Droplet className="w-12 h-12 text-blue-400 mb-4" />
                <h3 className="text-xl font-bold mb-3 text-white">Water Heater Malfunctions</h3>
                <ul className="text-blue-100 space-y-2">
                  <li>• Leaking tanks</li>
                  <li>• Strange noises</li>
                  <li>• Inefficient heating</li>
                </ul>
                <p className="mt-4 text-blue-300 font-semibold">Our Solution: $2,000 for 40-gal, $2,100 for 50-gal replacement</p>
              </div>
            </div>
            
            <div className="text-center">
              <Link to="/pricing" className="bg-gradient-to-r from-yellow-400 to-orange-500 hover:from-yellow-300 hover:to-orange-400 text-white px-8 py-4 rounded-full text-xl font-bold inline-block transition-all duration-300 shadow-xl hover:shadow-2xl transform hover:scale-105">
                See All Our Transparent Pricing
              </Link>
            </div>
          </div>
        </section>

        {/* Why Licensed Plumbers Matter Section - Light Gradient */}
        <section className="py-16 bg-gradient-to-bl from-blue-900 to-blue-950 overflow-hidden">
          <div className="container-custom relative z-10">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-white">
              Why Licensed Plumbers Matter in Arvada
            </h2>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center border border-white/20">
                <Shield className="w-16 h-16 text-green-400 mx-auto mb-4" />
                <h3 className="text-xl font-bold mb-3 text-white">Safety & Compliance</h3>
                <ul className="text-blue-100 text-left space-y-2">
                  <li>✓ Adherence to local building codes</li>
                  <li>✓ Safety standards compliance</li>
                  <li>✓ Proper permit acquisition</li>
                  <li>✓ Pass all inspections</li>
                </ul>
              </div>
              
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center border border-white/20">
                <Award className="w-16 h-16 text-yellow-400 mx-auto mb-4" />
                <h3 className="text-xl font-bold mb-3 text-white">Expertise & Training</h3>
                <ul className="text-blue-100 text-left space-y-2">
                  <li>✓ 30+ years combined experience</li>
                  <li>✓ Master Plumber credentials</li>
                  <li>✓ 18,000+ completed jobs</li>
                  <li>✓ Specialized equipment access</li>
                </ul>
              </div>
              
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center border border-white/20">
                <CheckCircle className="w-16 h-16 text-blue-400 mx-auto mb-4" />
                <h3 className="text-xl font-bold mb-3 text-white">Guaranteed Workmanship</h3>
                <ul className="text-blue-100 text-left space-y-2">
                                    <li>✓ Insurance protection</li>
                  <li>✓ Professional accountability</li>
                  <li>✓ 360 verified reviews</li>
                </ul>
              </div>
            </div>
            
            <div className="mt-12 text-center bg-white/10 backdrop-blur-sm rounded-xl p-8 max-w-4xl mx-auto border border-white/20">
              <h3 className="text-2xl font-bold mb-4 text-white">What to Look for When Hiring a Plumbing Company</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-left">
                <div>
                  <h4 className="font-bold text-yellow-400 mb-2">Essential Qualifications</h4>
                  <ul className="text-blue-100 space-y-1">
                    <li>• Full licensing and insurance for Colorado</li>
                    <li>• Established company with positive reviews</li>
                    <li>• Familiarity with Arvada's specific codes</li>
                  </ul>
                </div>
                <div>
                  <h4 className="font-bold text-green-400 mb-2">Service Quality Indicators</h4>
                  <ul className="text-blue-100 space-y-1">
                    <li>• Transparent, upfront pricing (like ours!)</li>
                    <li>• Emergency service availability</li>
                    <li>• Modern tools and techniques</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Final CTA Section - Dark Gradient */}
        <section className="py-20 bg-gradient-to-br from-blue-800 to-blue-900 overflow-hidden">
          <div className="container-custom text-center relative z-10">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">
              Ready for Honest, Transparent Plumbing Service in Arvada?
            </h2>
            <p className="text-xl mb-8 text-blue-100 max-w-3xl mx-auto">
              Join thousands of satisfied Arvada homeowners who trust Colorado First Plumbing for fair prices, quality work, and no-surprise billing.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-12">
              
              <Link 
                to="/contact" 
                className="bg-gradient-to-r from-green-500 to-green-600 hover:from-green-400 hover:to-green-500 text-white px-10 py-5 rounded-full text-2xl font-semibold inline-block transition-all duration-300 shadow-xl hover:shadow-2xl transform hover:scale-105"
              >
                📝 Get a Quote
              </Link>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                <MapPin className="w-12 h-12 text-yellow-400 mx-auto mb-3" />
                <h3 className="font-bold text-white mb-2">Serving All Arvada</h3>
                <p className="text-blue-100">From Old Town to Candelas, we're your local plumbers. Also serving <Link to="/littleton-plumber" className="text-blue-200 hover:text-blue-100 underline">Littleton</Link>, <Link to="/lakewood-plumber" className="text-blue-200 hover:text-blue-100 underline">Lakewood</Link>, <Link to="/denver-plumber" className="text-blue-200 hover:text-blue-100 underline">Denver</Link></p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                <Clock className="w-12 h-12 text-green-400 mx-auto mb-3" />
                <h3 className="font-bold text-white mb-2">Business Hours</h3>
                <p className="text-blue-100">Mon-Sat: 8 AM - 5 PM<br />Emergency service available</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                <Award className="w-12 h-12 text-orange-400 mx-auto mb-3" />
                <h3 className="font-bold text-white mb-2">Guaranteed Quality</h3>
                <p className="text-blue-100">Licensed, insured, and backed by 360 Google Reviews</p>
              </div>
            </div>
            
            <div className="mt-12 text-blue-100">
              <p className="text-sm">
                Colorado First Plumbing and Sewer LLC | Licensed Master Plumber Owned | Woman Majority Owned<br />
                Serving Arvada, Denver Metro, and Surrounding Areas Since 2018
              </p>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default ArvadaPlumber;